/* eslint no-console: ["error", { allow: ["warn", "error"] }] */
import agent from '@services/apiService';

import {
  SELECT_AGENT,
  SELECT_AGENT_FAIL,
  SELECT_AGENT_SUCCESS,
  GET_IMPERSONATION_DATA,
  GET_IMPERSONATION_DATA_SUCCESS,
  GET_IMPERSONATION_DATA_FAIL,
  GET_STATUS,
  GET_STATUS_SUCCESS,
  GET_STATUS_FAIL,
  HOME_BUTTON_CLICKED,
  IMPERSONATION_AGENT_LOOKUP,
  IMPERSONATION_AGENT_LOOKUP_FAIL,
  IMPERSONATION_AGENT_LOOKUP_SUCCESS,
  SEARCH_LISTINGS_PAGE_CLICKED,
  SET_GROUP_TYPE,
  START_IMPERSONATION,
  START_IMPERSONATION_SUCCESS,
  START_IMPERSONATION_FAIL,
  STOP_IMPERSONATION,
  STOP_IMPERSONATION_SUCCESS,
  STOP_IMPERSONATION_FAIL,
} from '../constants/ActionTypes';

const initialState = {
  agentGroupType: null,
  allowedUsers: [],
  clearAgent: false,
  impersonationAgentSearchResults: null,
  impersonationAgentSelected: null,
  impersonationStateChange: false,
  impersonationTargets: [],
  isImpersonating: null,
  isLoading: false,
  status: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_IMPERSONATION_DATA_SUCCESS:
      return {
        ...state,
        allowedUsers: action.payload.allowedUsers,
        impersonationTargets: action.payload.impersonationTargets,
      };
    case GET_IMPERSONATION_DATA_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case GET_STATUS_SUCCESS:
      return {
        ...state,
        status: action.payload,
      };
    case GET_STATUS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case HOME_BUTTON_CLICKED:
    case SEARCH_LISTINGS_PAGE_CLICKED:
      return {
        ...state,
      };
    case SET_GROUP_TYPE:
      return {
        ...state,
        agentGroupType: action.groupType,
      };
    case GET_IMPERSONATION_DATA:
    case START_IMPERSONATION:
    case IMPERSONATION_AGENT_LOOKUP:
      return {
        ...state,
        isLoading: true,
      };
    case IMPERSONATION_AGENT_LOOKUP_FAIL:
      return {
        ...state,
        isLoading: false,
        /* Error handling */
      };
    case IMPERSONATION_AGENT_LOOKUP_SUCCESS: {
      return {
        ...state,
        impersonationAgentSearchResults: action.payload.updatedAgents,
        isLoading: false,
      };
    }
    case START_IMPERSONATION_SUCCESS:
      return {
        ...state,
        isImpersonating: action.payload,
        impersonationStateChange: true,
      };
    case STOP_IMPERSONATION_SUCCESS:
      return {
        ...state,
        isImpersonating: false,
        impersonationStateChange: true,
      };
    case STOP_IMPERSONATION_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case START_IMPERSONATION_FAIL:
      return {
        ...state,
        isImpersonating: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

const startImpersonation = targetCriteria => async dispatch => {
  dispatch({ type: START_IMPERSONATION });
  try {
    await agent.Impersonation.Start({ userName: targetCriteria.memberMlsId });
    dispatch({
      type: START_IMPERSONATION_SUCCESS,
      payload: targetCriteria,
    });
  } catch (err) {
    console.error('Error: Impersonation startImpersonation', err);
    dispatch({ type: START_IMPERSONATION_FAIL, payload: err });
  }
};

const stopImpersonation = () => async dispatch => {
  dispatch({ type: STOP_IMPERSONATION });
  try {
    const status = await agent.Impersonation.Stop();
    dispatch({
      type: STOP_IMPERSONATION_SUCCESS,
      payload: { status },
    });
  } catch (err) {
    console.error('Error: Impersonation stopImpersonation', err);
    dispatch({ type: STOP_IMPERSONATION_FAIL, payload: err });
  }
};
const getStatus = () => async dispatch => {
  dispatch({ type: GET_STATUS });
  try {
    const result = await agent.Impersonation.GetStatus();
    dispatch({
      type: GET_STATUS_SUCCESS,
      payload: { ...result },
    });
  } catch (err) {
    console.error('Error: Impersonation getStatus', err);
    dispatch({ type: GET_STATUS_FAIL, payload: err });
  }
};
const getImpersonationData = () => async dispatch => {
  dispatch({ type: GET_IMPERSONATION_DATA });
  try {
    const list = await agent.Impersonation.GetImpersonationData();
    dispatch({
      type: GET_IMPERSONATION_DATA_SUCCESS,
      payload: { ...list },
    });
  } catch (err) {
    console.error('Error: Impersonation getImpersonationData', err);
    dispatch({ type: GET_IMPERSONATION_DATA_FAIL, payload: err });
  }
};
const separateAgentName = agents => agents.map(singleAgent => {
  const currentAgent = { ...singleAgent };
  // Split the name
  const splitName = currentAgent.MemberFullName.split(' ');
  if (splitName.length === 3) {
    currentAgent.MemberFirstName = splitName.slice(0, -1).join(' ');
    currentAgent.MemberLastName = splitName.slice(-1).join(' ');
  } else {
    const [firstName, lastName] = splitName;
    currentAgent.MemberFirstName = firstName;
    currentAgent.MemberLastName = lastName;
  }
  return currentAgent;
});
// Searches for agents
const agentSearch = agentCriteria => async dispatch => {
  dispatch({ type: IMPERSONATION_AGENT_LOOKUP });
  try {
    const agents = await agent.Agent.searchAgent(agentCriteria);
    const updatedAgents = separateAgentName(agents);
    dispatch({
      type: IMPERSONATION_AGENT_LOOKUP_SUCCESS,
      payload: { updatedAgents },
    });
  } catch (err) {
    console.error('Error: Impersonation agentSearch', err);
    dispatch({ type: IMPERSONATION_AGENT_LOOKUP_FAIL });
  }
};
const buildJson = row => {
  const jsonBody = {
    action: 'select',
    where: {
      clause: [
        {
          name: 'MemberMlsId',
          value: row.memberMlsId,
        },
      ],
    },
  };
  return jsonBody;
};
// Selects agent
const getTargetAgentData = agentData => async dispatch => {
  dispatch({ type: SELECT_AGENT });
  try {
    const agentBody = buildJson(agentData);
    const selectedAgent = await agent.Agent.selectAgent(agentBody);
    const fullAgent = { ...selectedAgent.agent };
    dispatch({
      type: SELECT_AGENT_SUCCESS,
      payload: { fullAgent },
    });
  } catch (err) {
    console.error('Error: Impersonation getTargetAgentData', err);
    dispatch({ type: SELECT_AGENT_FAIL });
  }
};

export {
  agentSearch,
  getImpersonationData,
  getStatus,
  getTargetAgentData,
  stopImpersonation,
  startImpersonation,
};
